import { animate, state, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FormControl } from '@angular/forms';
import { debounceTime, Observable, filter, share, startWith, Subject, takeUntil, switchMap } from 'rxjs';
import { AcvisService } from '@app/services/acvis.service';
import { CarrentFilters } from '@app/models/carrent/CarrentFilters';
import { CarrentFiltersService } from '@app/services/carrentfilters.service';
@Component({
    selector: 'app-city',
    templateUrl: './city.component.html',
    styleUrls: ['./city.component.scss'],
    animations: [
        trigger('zoom', [
            state('leftBottom', style({ transform: 'scale(0.3)', transformOrigin: 'left bottom', opacity: '0' })),
            state('default', style({ transform: 'scale(1)', opacity: '1' })),
            transition('* <=> default', animate('10ms cubic-bezier(0.25,1,.25,1)'))
        ])
    ],
    standalone: false
})
export class CityComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showModal: boolean = false;
    focus: boolean = true;
    suffix: string = 'Anmietungs und Rückgabeort';
    media: string = 'lg';
    origin = 'default';
    zielText = 'Anmietungs und Rückgabeort';

    searchObj: Observable<any>;
    mySearchControl = new FormControl();

    defaultdatas = [
        {
            code: 'PMI',
            name: 'Mallorca',
            country: { code: 'ES', name: 'Spanien' },
            type: 1
        },
        {
            code: 'IBZ',
            name: 'Ibiza',
            country: { code: 'ES', name: 'Spanien' },
            type: 1
        },
    ]

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected render: Renderer2,
        protected acvisService: AcvisService,
        protected carrentFilterService: CarrentFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        this.initMedia();
        this.initSearchChange();
        this.initFilterSub();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initFilterSub() {
        this.carrentFilterService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: CarrentFilters) => {
            if (filter?.arrivalAirportList?.name?.length > 0) {
                if (this.zielText !== filter.arrivalAirportList.name) {
                    this.zielText = filter.arrivalAirportList.name;
                }
            } else {
                this.zielText = 'Anmietungs und Rückgabeort';
            }
            this.cdr.detectChanges();
        });
    }

    initMedia() {
       if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    initSearchChange() {
        const filterShare = this.mySearchControl.valueChanges.pipe(
            startWith(''),
            debounceTime(100),
            filter(value => (typeof value === 'string' && value?.length > 0)),
            share()
        );

        this.searchObj = filterShare.pipe(
            switchMap(value => this.acvisService.request({
                searchValue: value,
                inAll: true
            }, 'airoportListCompletions'))
        );
    }

    openModal(ev) {
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    openModalMobile(ev) {
        // this.render.addClass(document.body, 'model-open');
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    closeModal() {
        this.showModal = false;
        this.cdr.detectChanges();
    }

    closeModalMobile() {
        this.showModal = false;
        // this.render.removeClass(document.body, 'model-open');
        this.cdr.detectChanges();
    }

    zoomin(position: any) {
        this.origin = position;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.origin = 'default';
            this.cdr.detectChanges();
        });
    }

    clearText() {
        this.mySearchControl.setValue('');
        this.focus = false;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.focus = true;
            this.cdr.detectChanges();
        }, 50);
    }

    selectValue(item) {
        if (item.type === -1) {
            this.zielText = 'Anmietungs und Rückgabeort';
            this.showModal = false;
            this.mySearchControl.setValue('');
            this.carrentFilterService.arrivalAirportList(null, this.mode);
        } else {
            this.zielText = item?.name + ' (' + item?.code + ')';
            this.showModal = false;
            this.mySearchControl.setValue('');
            this.carrentFilterService.arrivalAirportList({
                name: item.name,
                code: item.code
            }, this.mode);
        }
    }
}
